let resolve;

const recaptchaPromise = new Promise(res => {
  resolve = res;
});

window.recaptchaLoaded = () => {
  resolve(window.grecaptcha);
};

export default recaptchaPromise;



// WEBPACK FOOTER //
// ./src/scripts/utils/recaptcha.js